import { Table, Chip } from './Main.styles'
import { useBmsAuth } from './useBmsAuth'
import { useProductTags } from './useProductTags'
import { useState, useEffect } from 'react'

const Main = ({ plugin }: any) => {
   const fieldValue = plugin.getFieldValue(plugin.fieldPath)
   // state
   const [pluginLoading, setPluginLoading] = useState(true)
   const [tags, setField] = useState([]);
   // plugin configuration variables
   const username = plugin.parameters.global.bmsApiUser
   const password = plugin.parameters.global.bmsApiPassword
   const endpoint = plugin.parameters.global.bmsApiEndpoint
   // hooks
   const token = useBmsAuth({ endpoint, username, password })
   const { tags: bmsTags, fetchTags } = useProductTags({ endpoint })
   // user interaction
   const handleSetField = (newTags: any) => {
      plugin.setFieldValue(plugin.fieldPath, JSON.stringify(newTags));
   }

   // lifecycle methods

   useEffect(() => {
      if (typeof fieldValue !== 'undefined') {
         setField(JSON.parse(fieldValue))
         setPluginLoading(false)
      }
   }, [fieldValue])

   useEffect(() => {
      if (token) {
         fetchTags(token)
      }
   }, [token])

   useEffect(() => {
      const unsubscribe = plugin.addFieldChangeListener(plugin.fieldPath, (newValue: any) => {
         setField(JSON.parse(newValue));
      });
      return () => {
         unsubscribe();
      };
   }, [token]);

   // TODO debounce input change
   const handleChange = (event: any, tag: any) => {
      const newTags = tags.map((t) => {
         if (t.id === tag.id) {
            return { ...t, datoName: event.target.value }
         }
         return t
      })
      handleSetField(newTags)
   }


   useEffect(() => {
      if (tags.length === 0 && bmsTags.length > 0 && !pluginLoading) {
         const sortedTags = bmsTags
            .filter(tag => tag.active)
            .map((tag) => ({ id: tag.id, name: tag.name, active: tag.active, datoName: tag.name }))
            .sort((a, b) => a.name.localeCompare(b.name))
         handleSetField(sortedTags);
      }
   }, [tags.length, bmsTags.length, pluginLoading]);

   return <Table>
      <thead>
         <tr>
            <th>
               BMS
            </th>
            <th>
               Website
            </th>
         </tr>
      </thead>
      <tbody>
         {tags.map((tag: any) => {
            return <tr key={tag.id}>
               <td>
                  {tag.name} <Chip active={tag.active}>ID: {tag.id}</Chip>
               </td>
               <td>
                  <input type="text" defaultValue={tag.datoName} onChange={(event) => handleChange(event, tag)} />
               </td>
            </tr>
         })}
      </tbody>
   </Table>
}

export default Main;
